import { Alerter, Intent } from '@pinpointhq/thumbtack';
import { useEffect, useState } from 'react';
import { visit } from '../utilities/turbolinks';

export interface IUseDiscardChangesHook {
  isEdited: boolean;
  renderAlerter(callback: () => void): void;
  setIsEdited(value: boolean): void;
}

export function useDiscardChanges(initialState = false): IUseDiscardChangesHook {
  const [isEdited, setIsEdited] = useState<boolean>(initialState);

  useEffect(() => {
    document.addEventListener('turbolinks:before-visit', handleTurbolinksVisit);
    return () => {
      document.removeEventListener('turbolinks:before-visit', handleTurbolinksVisit);
    };
  }, [isEdited]);

  const handleTurbolinksVisit = (event) => {
    const path = (event as any).data.url;
    if (isEdited) {
      event.preventDefault();
      renderAlerter(() => handleFollowClick(path));
    }
  };

  const renderAlerter = (callback) => {
    Alerter.create({
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Yes, discard',
      intent: Intent.DANGER,
      onConfirm: callback,
      text: 'Are you sure you want to leave this page? Any unsaved changes will be lost',
    });
  };

  const handleFollowClick = (path: string) => {
    // Important that this is done before trying to visit otherwise we end up infinitely looping
    document.removeEventListener('turbolinks:before-visit', handleTurbolinksVisit);
    visit(path);
  };

  return {
    isEdited,
    renderAlerter,
    setIsEdited,
  };
}

